import { Button } from '@lmig/lmds-react-button';
import { GridCol, GridRow } from '@lmig/lmds-react-grid';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@lmig/lmds-react-modal';
import { Notification } from '@lmig/lmds-react-notification';
import { useState } from 'react';
import { triggerGoal } from 'Utilities/GoalManager';
import { ICTA } from './Models/UpdateObjectCTAModels';

const UpdateObjectCTA = (props: ICTA) => {
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(undefined as string | undefined);
  const [isOpen, setIsOpen] = useState(false);
  if (props === null) return null;

  const modalText = props?.modalText?.replace('&lsquo;', "'").replace('&rsquo;', "'");

  const sendRequest = async (rewardId: string) => {
    if (rewardId === null) {
      setError(props.errorText);
      return;
    }
    if (isSending) return;

    setIsSending(true);

    await fetch('/api/sitecore/Rewards/SubmitUpdateObjectCTA', {
      method: 'POST',
      body: new URLSearchParams({ reward: rewardId }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setIsSending(false);

          if (result === false)
            //false is returned if agent or reward objects are empty
            setError(props.errorText);
          else setIsOpen(false);
        },
        () => {
          setError(props.errorText);
        },
      );
  };

  const submit = () => {
    setError(undefined); //in the case of a resubmit after receiving an error, clear the error
    triggerGoal(props.closeButtonGoal);
    sendRequest(props.rewardId);
  };

  const openModal = () => {
    setError(undefined);
    triggerGoal(props.ctaButtonGoal);
    setIsOpen(true);
  };

  return (
    <>
      <Modal isOpen={isOpen} size="large" onClose={() => setIsOpen(false)}>
        <ModalBody>
          <ModalHeader>{props.modalTitle}</ModalHeader>
          <p className="paragraph-text">{modalText}</p>
          {isSending ? (
            <img src="/-/media/Project/Safeco/shared/Rewards/spinner.gif" alt="loading" className="loading-spinner" />
          ) : (
            <></>
          )}
          {error ? (
            <Notification alert={props.errorText} highlightType="negative" style={{ marginTop: '24px' }} />
          ) : (
            <></>
          )}
        </ModalBody>
        <ModalFooter>
          <GridRow gutterSize="fixed-16" gutters>
            <GridCol base={12} md={6}>
              <Button
                disabled={isSending}
                onClick={() => submit()}
                style={{ display: 'flex', margin: 'auto', marginTop: '2em' }}
                variant="primary"
              >
                {props.closeButton}
              </Button>
            </GridCol>
          </GridRow>
        </ModalFooter>
      </Modal>
      <Button variant="primary" size={props.size} style={{ marginLeft: '0px' }} onClick={() => openModal()}>
        {props.ctaButton}
      </Button>
    </>
  );
};
export default UpdateObjectCTA;
